import { Action } from '@ngrx/store';

export const GET_CURRENT_USER = '[Security] Get Current User';

export class GetCurrentUserProfileAction implements Action {
  readonly type = GET_CURRENT_USER;
}



// WEBPACK FOOTER //
// ./src/app/security/store/actions/GetCurrentUserProfileAction.ts